import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import DomElementPropType from 'components/dom_element_prop_type';
import FormGroup from 'components/form_group';
import FormTooltip, { tooltipPropShape, tooltipDefaultProp } from 'components/form_tooltip';
import TouchedFieldError from 'components/touched_field_error';

const Input = ({
  disabled,
  formGroupClassName,
  formGroupIcon,
  formGroupLabel,
  inputClassName,
  inputId,
  inputMax,
  inputMin,
  name,
  placeholder,
  innerRef,
  step,
  tooltip,
  type,
}) => {
  const { content, header, position } = tooltip;
  return (
    <FormGroup
      className={formGroupClassName}
      icon={formGroupIcon}
      label={formGroupLabel}
      htmlFor={inputId || name}
    >
      <FormTooltip content={content} header={header} position={position}>
        <Field
          className={inputClassName}
          disabled={disabled}
          id={inputId || name}
          max={inputMax}
          min={inputMin}
          name={name}
          placeholder={placeholder}
          innerRef={innerRef}
          step={step}
          type={type}
        />
      </FormTooltip>
      <TouchedFieldError field={name} />
    </FormGroup>
  );
};

Input.defaultProps = {
  disabled: false,
  formGroupClassName: null,
  formGroupIcon: null,
  formGroupLabel: null,
  innerRef: null,
  inputClassName: 'form-control',
  inputId: null,
  inputMax: null,
  inputMin: null,
  name: null,
  placeholder: null,
  step: null,
  tooltip: tooltipDefaultProp,
  type: null,
};

Input.propTypes = {
  disabled: PropTypes.bool,
  formGroupClassName: PropTypes.string,
  formGroupIcon: PropTypes.string,
  formGroupLabel: PropTypes.string,
  innerRef: PropTypes.shape({ current: DomElementPropType }),
  inputClassName: PropTypes.string,
  inputId: PropTypes.string,
  inputMax: PropTypes.number,
  inputMin: PropTypes.number,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  step: PropTypes.string,
  tooltip: tooltipPropShape,
  type: PropTypes.string,
};

export default Input;
